@if (textConfig) {
  <div class="Typeahead__Control">
    <control-text
      (inputChanged)="onInputChange($event)"
      autocomplete="off"
      [config]="textConfig"
      [control]="control"
      class="TypeAheadInput"
    >
    </control-text>
    <div (click)="clearInput()" class="Typeahead--icon-close">
      @if (showClose) {
        <icon name="close" [config]="{ size: 'small' }"></icon>
      }
    </div>
  </div>
  @if (config['canListAllOptions']) {
    <ng-container typeaheadWithDropdown>
      <div
        class="u-flex u-justifyEnd Typeahead--icons"
        (click)="getAllExternalOptions()"
        [class.Typeahead--icons-input-icon]="config.icon"
        [class.Typeahead--icons-close]="showAllOptions"
      >
        @if (!showClose && !showAllOptions && !loading) {
          <icon name="carat_down"></icon>
        }
        @if (!showClose && showAllOptions && !loading) {
          <icon
            class="Typeahead--close"
            name="close"
            [config]="{ size: 'small' }"
          ></icon>
        }
        @if (loading) {
          <preloader size="small"></preloader>
        }
      </div>
    </ng-container>
  }
  @if (noSearchResults && config?.noResults) {
    <p class="Typeahead__no-results">
      {{ config?.noResults }}
    </p>
  }
}

@if (showMenu) {
  <accessible-options
    [onSiblingKeyDown]="keyDown$"
    [options]="filteredOptions"
    (selected)="select($event)"
  >
  </accessible-options>
}

@if (showAllOptions && !filteredOptions.length) {
  <accessible-options [options]="allOptions" (selected)="select($event)">
  </accessible-options>
}

@if (showAllOptions && allOptions?.length === 0) {
  <div class="Typeahead__no-results">
    <p class="Typeahead__no-results-text">No Results</p>
  </div>
}
